import normalizeLabel from './normalizeLabel';

/**
 * The Title values under which an email can live in PersonaData (mirrors the
 * CONTACT_TITLES set used by TaskReminders.jsx). Compared after normalization.
 */
const EMAIL_TITLES = ['Email', 'E-mail', 'e-mail', 'email', 'E-mailadres', 'Emailadres'];
const EMAIL_TITLE_KEYS = new Set(EMAIL_TITLES.map(normalizeLabel));

/**
 * Finds an existing persona by email address among PersonaData rows. A persona's email
 * is stored as a PersonaData row (`Title: "Email"`, `Value: <email>`) — there is no
 * Email field on the Persona doc. Matching is tolerant of title variants and value casing.
 *
 * @param {Array<{PersonaID?: string, Title?: string, Value?: string}>} personaDataRows - PersonaData docs for the tenant.
 * @param {string} email - The email to look up.
 * @returns {string|null} The matching `PersonaID`, or null when none matches.
 */
const findPersonaByEmail = (personaDataRows, email) => {
    const target = normalizeLabel(email);
    if (!target || !Array.isArray(personaDataRows)) return null;

    const match = personaDataRows.find(
        (row) =>
            EMAIL_TITLE_KEYS.has(normalizeLabel(row?.Title)) &&
            normalizeLabel(row?.Value) === target
    );

    return match?.PersonaID || null;
};

export default findPersonaByEmail;
